import { render, staticRenderFns } from "./PaymentInstallments.vue?vue&type=template&id=b53e8718&scoped=true"
import script from "./PaymentInstallments.vue?vue&type=script&lang=js"
export * from "./PaymentInstallments.vue?vue&type=script&lang=js"
import style0 from "./PaymentInstallments.vue?vue&type=style&index=0&id=b53e8718&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53e8718",
  null
  
)

export default component.exports